import React, { useState } from "react";

import { Checkbox, Grid, makeStyles } from "@material-ui/core";
import { OfqualNotification } from "../services/domain/OfqualNotification";
import { NotificationsViewState } from "../redux/state";
import { NotificationMenu } from "./NotificationMenu";
import { utcToLocalDateTime } from "../utils/dateUtils";

export type NotificationProps = {
  notification: OfqualNotification;
  viewState: NotificationsViewState;
  readingNotification: () => void;
  toggleBulkModeClearNotification: (isChecked: boolean) => void;
  actions?: { label: string; action: () => void; href?: string }[];
};

const useStyles = makeStyles((theme) => ({
  bulkModeControls: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  actions: {
    textAlign: "right",
    // minHeight: "40px",
    // marginTop: "20px",
  },
  important: {
    borderLeft: "red 4px solid !important",
  },
  read: {
    backgroundColor: "rgba(200, 200, 200, 0.1)!important",
    border: "dashed 1px #ddd!important",
    // opacity: 0.4,
    // boxShadow: "0",
  },
  root: {
    padding: "10px",
    margin: "20px",
    // marginBottom: "15px",
    backgroundColor: "white",
    boxShadow: "0px 0px 19px -2px rgba(163, 163, 163, 0.3)",
    border: "1px solid #ddd",
    borderRadius: "3px",
  },
  dates: {
    textAlign: "left",
    paddingLeft: "80px",
  },
  details: {
    // minHeight: "90px",
  },
  reading: {
    // visibility: "hidden",
    opacity: 0,

    transition:
      "visibility 0.5s linear, opacity 0.5s linear, height 0.5s linear, right 0.5s linear",
  },
}));

export const Notification: React.FC<NotificationProps> = ({
  notification,
  viewState,
  readingNotification,
  toggleBulkModeClearNotification,
  actions = [],

  children,
}) => {
  const classes = useStyles();

  const isBulkModeCheckedForThisNotification = viewState.notificationsToClear.includes(
    notification.id
  );

  const [isReading, setIsReading] = useState(false);

  const localReadingNotification = () => {
    // we interecpt the readingNotification command to adjust our css to give a fade out effect
    setIsReading(true);
    readingNotification();
  };

  return (
    <div
      className={`
      ${classes.root} 
      ${notification.important ? classes.important : ""}
      ${notification.read ? classes.read : ""}
      ${isReading ? classes.reading : ""}
      `}
      data-test="notification-row"
    >
      <Grid container className={classes.details}>
        <Grid item xs={11}>
          {children}
        </Grid>
        <Grid item xs={1} className={classes.bulkModeControls}>
          {viewState.isBulkMode && !notification.read ? (
            <Checkbox
              checked={isBulkModeCheckedForThisNotification}
              name={`bulk-mode-checkbox-${notification.id}`}
              onChange={() =>
                toggleBulkModeClearNotification(
                  !isBulkModeCheckedForThisNotification
                )
              }
            />
          ) : null}
        </Grid>
      </Grid>
      <div className={classes.dates}>
        <strong>Notification received:</strong>{" "}
        {utcToLocalDateTime(notification.createdAt)}
      </div>
      <div className={classes.actions}>
        {notification.read ? (
          <div className={classes.dates}>
            <strong>Read At</strong>{" "}
            <span>{utcToLocalDateTime(notification.readAt)}</span>
          </div>
        ) : null}
        {!viewState.isBulkMode ? (
          <NotificationMenu
            actions={actions}
            readingNotification={localReadingNotification}
            showClear={!notification.read}
          />
        ) : null}
      </div>
    </div>
  );
};
